import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { usePageTitle } from '../../hooks/usePageTitle';
import { TipoUsuario } from '../../types';
import Button from '../../components/Common/Button';
import Input from '../../components/Common/Input';
import { validateRequired, validateEmail, validateMinLength, combineValidations } from '../../utils/validations';

const Login: React.FC = () => {
  usePageTitle('Login');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);

  const { login, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAuthenticated && user) {
      navigate(
        user.tipo === TipoUsuario.Administrador ? '/admin/estabelecimentos' : '/dashboard',
        { replace: true }
      );
    }
  }, [isAuthenticated, user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const userData = await login({ email, senha });
      navigate(
        userData.tipo === TipoUsuario.Administrador ? '/admin/estabelecimentos' : '/dashboard',
        { replace: true }
      );
    } catch (error) {
      // Error toast já é mostrado no AuthContext
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-500 via-primary-600 to-secondary-500 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl border border-neutral-100 p-8 w-full max-w-md animate-fadeIn">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="Gestta" className="h-12 mx-auto mb-3" />
          <p className="text-neutral-500 text-sm font-medium">A maneira mais simples de organizar as vendas e entender o lucro do seu negócio.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <Input
            label="Email *"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="seu@email.com"
            onValidate={combineValidations(validateRequired('Email'), validateEmail)}
            validateOnBlur
          />

          <Input
            label="Senha *"
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            placeholder="••••••••"
            onValidate={combineValidations(validateRequired('Senha'), validateMinLength(6, 'Senha'))}
            validateOnBlur
          />

          <Button
            type="submit"
            variant="primary"
            size="lg"
            fullWidth
            disabled={loading}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </form>

        <p className="text-center text-sm text-neutral-500 mt-5">
          Não tem conta?{' '}
          <Link
            to="/cadastro"
            className="text-primary-600 hover:text-primary-700 font-semibold hover:underline"
          >
            Cadastre-se
          </Link>
        </p>

        <p className="text-center text-sm text-neutral-500 mt-3 font-medium">
          Gestta v1.0
        </p>
      </div>
    </div>
  );
};

export default Login;
